import React from 'react'
import commonStyle from '../Utils/Common.less'
export const customizeRequiredMark = (
    label: React.ReactNode,
    { required }: { required: boolean }
): React.ReactElement => (
    <>
        {label}
        &nbsp;
        {required && <span className={commonStyle.requireIcon}>*</span>}
    </>
)
